// MK6.1 3D viewer (ported from MK6.1_scroll_viewer.html). Three modes:
//   [data-mk61]              homepage hero: scroll-to-assemble, drag to orbit (sections/homepage-hero.liquid)
//   [data-mk61="orbit"]      rifle builder: assembled model, drag to rotate, wheel/pinch to zoom (sections/rifle-builder.liquid)
//   [data-mk61="accessory"]  rifle builder: close-up of the selected accessory (standing block)
// The rifle builder viewers follow the configurator through the `projectlp:config` event (configurator.js).
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.170.0/+esm';
import { GLTFLoader } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/loaders/GLTFLoader.js/+esm';
import { OrbitControls } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/controls/OrbitControls.js/+esm';
import { RoomEnvironment } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/environments/RoomEnvironment.js/+esm';
import { MeshoptDecoder } from 'https://cdn.jsdelivr.net/npm/three@0.170.0/examples/jsm/libs/meshopt_decoder.module.js/+esm';

// seating order + explode direction (glTF frame: x butt->muzzle, y up, z toward viewer's right side) + distance (m)
const PLAN = [{"name":"Bedding block","dir":[0.0,1.0,-0.0],"dist":0.2,"seat":2.5,"dur":0.5,"major":true,"group":"bed"},{"name":"Screw.006","dir":[-0.0,-0.0,1.0],"dist":0.075,"seat":2.64,"dur":0.3,"major":false,"group":"hw"},{"name":"Cheekpiece insert","dir":[0.0,1.0,-0.0],"dist":0.16,"seat":2.94,"dur":0.5,"major":true,"group":"cheek"},{"name":"Screw.016","dir":[0.0,1.0,-0.0],"dist":0.075,"seat":3.08,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.015","dir":[0.0,1.0,-0.0],"dist":0.075,"seat":3.14,"dur":0.3,"major":false,"group":"hw"},{"name":"Cheekpiece hardware","dir":[0.0,1.0,-0.0],"dist":0.2,"seat":3.44,"dur":0.5,"major":true,"group":"cheek"},{"name":"Cheekpiece","dir":[-0.14834046363830566,0.9889363646507263,-0.0],"dist":0.26,"seat":3.7399999999999998,"dur":0.5,"major":true,"group":"cheek"},{"name":"Screw.009","dir":[-0.9911287426948547,-0.11683820933103561,0.06334608048200607],"dist":0.075,"seat":3.88,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.010","dir":[0.48498794436454773,-0.7687973380088806,0.416818231344223],"dist":0.075,"seat":3.94,"dur":0.3,"major":false,"group":"hw"},{"name":"Buttplate adjuster","dir":[-1.0,-0.0,0.0],"dist":0.18,"seat":4.24,"dur":0.5,"major":true,"group":"butt"},{"name":"Screw.007","dir":[-0.8783702850341797,0.47791627049446106,-0.00785181112587452],"dist":0.075,"seat":4.38,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.008","dir":[-0.8774937987327576,-0.47952383756637573,-0.007843859493732452],"dist":0.075,"seat":4.4399999999999995,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.006","dir":[-0.9889405965805054,-0.029086550697684288,-0.14543232321739197],"dist":0.075,"seat":4.5,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.020","dir":[-0.9884477853775024,-0.01576763577759266,0.1507394164800644],"dist":0.075,"seat":4.56,"dur":0.3,"major":false,"group":"hw"},{"name":"Washer","dir":[-0.0,-0.0,1.0],"dist":0.075,"seat":4.62,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.007","dir":[-0.6172130703926086,-0.15430383384227753,-0.7715169191360474],"dist":0.075,"seat":4.68,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.019","dir":[-0.3581776022911072,-0.09713202714920044,0.9285871982574463],"dist":0.075,"seat":4.74,"dur":0.3,"major":false,"group":"hw"},{"name":"Washer.001","dir":[-0.0,-0.0,1.0],"dist":0.075,"seat":4.8,"dur":0.3,"major":false,"group":"hw"},{"name":"Buttplate","dir":[-1.0,-0.0,0.0],"dist":0.26,"seat":5.1,"dur":0.5,"major":true,"group":"butt"},{"name":"Screw.013","dir":[-1.0,-0.0,0.0],"dist":0.075,"seat":5.239999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.011","dir":[-1.0,-0.0,0.0],"dist":0.075,"seat":5.299999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.012","dir":[-1.0,-0.0,0.0],"dist":0.075,"seat":5.359999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Nut","dir":[0.05538978427648544,-0.9984292984008789,0.008415368385612965],"dist":0.075,"seat":5.419999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Top hook","dir":[-0.7808687686920166,0.6246950030326843,-0.0],"dist":0.24,"seat":5.72,"dur":0.5,"major":true,"group":"butt"},{"name":"Bottom hook","dir":[-0.7808687686920166,-0.6246950030326843,0.0],"dist":0.24,"seat":6.02,"dur":0.5,"major":true,"group":"butt"},{"name":"Pistol grip","dir":[-0.0,-1.0,0.0],"dist":0.22,"seat":6.319999999999999,"dur":0.5,"major":true,"group":"grip"},{"name":"Screw.017","dir":[0.0,1.0,-0.0],"dist":0.075,"seat":6.459999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.009","dir":[-0.6636439561843872,0.700492799282074,-0.2624624967575073],"dist":0.075,"seat":6.519999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.018","dir":[0.0,1.0,-0.0],"dist":0.075,"seat":6.579999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.010","dir":[0.49054574966430664,0.8368372321128845,-0.24303995072841644],"dist":0.075,"seat":6.639999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Trigger guard","dir":[0.14834046363830566,-0.9889363646507263,-0.0],"dist":0.2,"seat":6.9399999999999995,"dur":0.5,"major":true,"group":"grip"},{"name":"Standing clamp","dir":[-0.0,-1.0,0.0],"dist":0.16,"seat":7.239999999999999,"dur":0.5,"major":true,"group":"stand"},{"name":"Standing block","dir":[0.09950371831655502,-0.9950371384620667,-0.0],"dist":0.26,"seat":7.539999999999999,"dur":0.5,"major":true,"group":"stand"},{"name":"Sling rail","dir":[0.2873478829860687,-0.9578262567520142,-0.0],"dist":0.16,"seat":7.839999999999999,"dur":0.5,"major":true,"group":"rail"},{"name":"Screw.002","dir":[-0.9926102757453918,0.12134581804275513,9.208227857016027e-05],"dist":0.075,"seat":7.979999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.001","dir":[0.019987402483820915,0.999799907207489,0.0007586899446323514],"dist":0.075,"seat":8.04,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw","dir":[0.9966683983802795,0.08156047761440277,6.189150008140132e-05],"dist":0.075,"seat":8.099999999999998,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert","dir":[0.984337568283081,0.1762922704219818,-0.000706621678546071],"dist":0.075,"seat":8.159999999999998,"dur":0.3,"major":false,"group":"hw"},{"name":"Harness rail","dir":[0.0,0.0,-1.0],"dist":0.14,"seat":8.459999999999999,"dur":0.5,"major":true,"group":"rail"},{"name":"Screw.003","dir":[-0.9914699196815491,-0.0033292740117758512,0.1302931308746338],"dist":0.075,"seat":8.6,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.004","dir":[-0.019390644505620003,-0.025539042428135872,0.9994856715202332],"dist":0.075,"seat":8.66,"dur":0.3,"major":false,"group":"hw"},{"name":"Screw.005","dir":[0.99138343334198,-0.003346045268699527,0.1309494823217392],"dist":0.075,"seat":8.719999999999999,"dur":0.3,"major":false,"group":"hw"},{"name":"Harness clip","dir":[0.0,-0.2873478829860687,-0.9578262567520142],"dist":0.16,"seat":9.02,"dur":0.5,"major":true,"group":"harness"},{"name":"Screw.014","dir":[-0.0,-0.0,1.0],"dist":0.075,"seat":9.16,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.008","dir":[-0.02232935093343258,0.003212533425539732,0.9997455477714539],"dist":0.075,"seat":9.22,"dur":0.3,"major":false,"group":"hw"},{"name":"Prone grip","dir":[0.1961161345243454,-0.9805806875228882,-0.0],"dist":0.22,"seat":9.52,"dur":0.5,"major":true,"group":"prone"},{"name":"Clip holder","dir":[0.0,0.4472135901451111,0.8944271802902222],"dist":0.2,"seat":9.82,"dur":0.5,"major":true,"group":"clip"},{"name":"Magnet.001","dir":[-0.9854465126991272,-0.12419335544109344,0.11606621742248535],"dist":0.075,"seat":9.96,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.002","dir":[-0.7698349356651306,-0.5507828593254089,-0.3224785327911377],"dist":0.075,"seat":10.020000000000001,"dur":0.3,"major":false,"group":"hw"},{"name":"Magnet","dir":[-0.8881276249885559,-0.3357852101325989,0.31381160020828247],"dist":0.075,"seat":10.08,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.005","dir":[-0.2420073002576828,0.0736013874411583,-0.9674788117408752],"dist":0.075,"seat":10.14,"dur":0.3,"major":false,"group":"hw"},{"name":"Magnet.002","dir":[0.8881276249885559,-0.3357852101325989,0.31381160020828247],"dist":0.075,"seat":10.200000000000001,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.004","dir":[0.835942268371582,0.04163122549653053,-0.5472359657287598],"dist":0.075,"seat":10.260000000000002,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.001","dir":[0.8948164582252502,-0.3852580487728119,-0.22556522488594055],"dist":0.075,"seat":10.32,"dur":0.3,"major":false,"group":"hw"},{"name":"Magnet.003","dir":[0.9854463338851929,-0.1241934597492218,0.11606630682945251],"dist":0.075,"seat":10.38,"dur":0.3,"major":false,"group":"hw"},{"name":"Brass insert.003","dir":[0.9569207429885864,0.022024812176823616,-0.2895127236843109],"dist":0.075,"seat":10.440000000000001,"dur":0.3,"major":false,"group":"hw"},{"name":"Clip cover","dir":[0.0,0.4472135901451111,0.8944271802902222],"dist":0.28,"seat":10.74,"dur":0.5,"major":true,"group":"clip"}];

// finishes matched to the finished MK6 photo (from the viewer's Finishes panel)
const FIN = {
  stock:    {gradient:[[.53,'#1426a8'],[.61,'#4a22a4'],[.69,'#9a127c']], roughness:.28, metalness:0, coat:1},
  grip:     {color:'#1a1a1c', roughness:.68, metalness:.15},
  cheek:    {color:'#46484c', roughness:.66, metalness:.1},
  alu:      {color:'#e4e4e6', roughness:.32, metalness:1},
  alu_dark: {color:'#2f2f33', roughness:.4, metalness:1},
  clip:     {color:'#1c1c1e', roughness:.45, metalness:0},
  letter:   {color:'#f0f0f0', roughness:.35, metalness:0},
  carbon:   {color:'#202022', roughness:.2, metalness:0, coat:1},
  steel:    {color:'#cfcfd1', roughness:.22, metalness:1},
  brass:    {color:'#eecb8f', roughness:.25, metalness:1},
};

// Swappable accessories in assets/mk61-parts.js, one node per option (<prefix>_<key>), all in this assembly's frame.
//   cfg:     the projectlp:config field that selects it (configurator.js)
//   options: configurator value -> node key (Custom shows the standard part)
//   builtIn: the node in mk61-model it replaces on the main rifle
const PARTS = {
  SB: {cfg: 'standingBlock', title: 'Standing block', builtIn: 'Standing_block', mat: 'grip',
       options: {'ProjectLP Original': 'original', 'Small hands': 'small', 'French style': 'french', 'Custom': 'original'},
       labels: {original: 'ProjectLP Original', small: 'Small hands', french: 'French style'}},
  CP: {cfg: 'cheekpiece', title: 'Cheekpiece', builtIn: 'Cheekpiece', mat: 'cheek',
       options: {'Short': 'short', 'Regular': 'regular', 'Tall': 'tall'},
       labels: {short: 'Short', regular: 'Regular', tall: 'Tall'}},
  PG: {cfg: 'grip', title: 'Pistol grip', builtIn: 'Pistol_grip', mat: 'grip',
       options: {'Wide': 'wide', 'Slim': 'slim', 'Custom': 'wide'},
       labels: {wide: 'Wide', slim: 'Slim'}},
};
const DEFAULT_KEY = {SB: 'original', CP: 'regular', PG: 'wide'};
const partFor = (g, cfg) => PARTS[g].options[cfg && cfg[PARTS[g].cfg]] || DEFAULT_KEY[g];

// split the parts scene into {SB: {original: node, ...}, CP: {...}, PG: {...}}
function groupParts(sceneRoot){
  const out = {SB: {}, CP: {}, PG: {}};
  for (const o of sceneRoot.children.slice()) {
    const m = /^(SB|CP|PG)_(\w+)$/.exec(o.name);
    if (m) out[m[1]][m[2]] = o;
  }
  return out;
}
const isLeft = cfg => !!cfg && cfg.side === 'Left';

// Left-hand build = mirror image across the stock's vertical centre plane (glTF z is across the stock).
// Mirroring a wrapper group keeps the stock's own transforms (hero animation, recoil) untouched;
// three.js flips face winding for negative scale, so lighting stays correct.
function setHand(group, left, centreZ = 0){
  group.scale.z = left ? -1 : 1;
  group.position.z = left ? 2 * centreZ : 0;
  group.updateMatrixWorld(true);
}

const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const clamp01 = v => Math.min(1, Math.max(0, v));

// base64 GLB modules are fetched once and parsed per viewer (a scene graph cannot be shared)
const glbBytes = {};
async function loadScene(url){
  const href = new URL(url, location.href).href;
  glbBytes[href] = glbBytes[href] || import(href).then(({ default: b64 }) => Uint8Array.from(atob(b64), c => c.charCodeAt(0)));
  const bytes = await glbBytes[href];
  const gl = new GLTFLoader(); gl.setMeshoptDecoder(MeshoptDecoder);
  return (await gl.parseAsync(bytes.slice().buffer, '')).scene;
}

function finishMaterial(key){
  const f = FIN[key], m = new THREE.MeshPhysicalMaterial({name: key});
  m.roughness = f.roughness; m.metalness = f.metalness; m.clearcoat = f.coat || 0; m.clearcoatRoughness = .04;
  if (f.color) m.color.setStyle(f.color);
  return m;
}

function makeViewer(canvas, zoom){
  const renderer = new THREE.WebGLRenderer({canvas, antialias:true, alpha:false});
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.toneMapping = THREE.AgXToneMapping; renderer.toneMappingExposure = 1.0;
  renderer.setClearColor(0x0a0a0a, 1);
  const scene = new THREE.Scene();
  const pm = new THREE.PMREMGenerator(renderer);
  scene.environment = pm.fromScene(new RoomEnvironment(), 0.04).texture;
  scene.environmentIntensity = 0.35;
  const key = new THREE.DirectionalLight(0xfff4ea, 2.2); key.position.set(-1, 1.6, 1.4); scene.add(key);
  const rim = new THREE.DirectionalLight(0xd6e4ff, 3.0); rim.position.set(1.2, .8, -1.5); scene.add(rim);
  const camera = new THREE.PerspectiveCamera(32, 1, .01, 50);
  const controls = new OrbitControls(camera, canvas);
  controls.enableZoom = zoom; controls.enablePan = false; controls.enableDamping = true;
  controls.minPolarAngle = .35; controls.maxPolarAngle = 2.2;
  // without zoom (hero), OrbitControls' touch-action:none would trap page scroll on phones;
  // with zoom, keep it so one finger rotates and two fingers pinch-zoom.
  if (!zoom) canvas.style.touchAction = 'pan-y';
  return {renderer, scene, camera, controls};
}

// render only while on screen
function runWhileVisible(host, tick){
  let running = false, raf = 0;
  const loop = t => { tick(t); if (running) raf = requestAnimationFrame(loop); };
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting && !running) { running = true; raf = requestAnimationFrame(loop); }
    else if (!e.isIntersecting) { running = false; cancelAnimationFrame(raf); }
  }).observe(host);
}

async function mount(host){
  const canvas = host.querySelector('canvas');
  const orbit = host.dataset.mk61 === 'orbit';
  const stage = host.querySelector('.hero-3d-stage') || host;

  if (!orbit) {
    // stage sits just below the sticky nav
    const nav = document.querySelector('.nav-split');
    const setTop = () => host.style.setProperty('--hero-top', (nav ? nav.offsetHeight : 0) + 'px');
    setTop(); addEventListener('resize', setTop);
  }

  const {renderer, scene, camera, controls} = makeViewer(canvas, orbit);
  const root = await loadScene(canvas.dataset.model);
  const hand = new THREE.Group(); hand.add(root); scene.add(hand);

  const box = new THREE.Box3().setFromObject(root);
  const ctr = box.getCenter(new THREE.Vector3()), size = box.getSize(new THREE.Vector3());
  controls.target.copy(ctr);
  const R = size.length();
  if (orbit) { controls.minDistance = R * .3; controls.maxDistance = R * 2.2; }

  const cover = root.getObjectByName('Clip_cover');
  if (cover) root.children.concat().forEach(o => { if (/^Lettering/.test(o.name)) cover.attach(o); });
  const parts = [];
  const T0p = Math.min(...PLAN.map(p => p.seat - p.dur)), T1p = Math.max(...PLAN.map(p => p.seat)), SPAN = .86;
  PLAN.forEach((p, i) => {
    const o = root.getObjectByName(THREE.PropertyBinding.sanitizeNodeName(p.name)) || root.getObjectByName(p.name);
    if (!o) return;
    const dir = new THREE.Vector3(...p.dir).normalize();
    const ax = dir.clone().cross(Math.abs(dir.y) < .9 ? new THREE.Vector3(0,1,0) : new THREE.Vector3(1,0,0)).normalize();
    const ang = (12 + (i * 37) % 10) * Math.PI / 180 * (i % 2 ? 1 : -1) * (p.major ? 1 : 1.6);
    const bs = new THREE.Box3().setFromObject(o).getSize(new THREE.Vector3());
    parts.push({o, home:o.position.clone(), q0:o.quaternion.clone(), dir, dist:p.dist, ax, ang, prev: orbit ? 1 : 0, hit:null, group:p.group,
                amp: Math.min(.010, .002 + .05 * Math.max(bs.x, bs.y, bs.z)) * (p.major ? 1 : .8),
                a: .04 + SPAN * (p.seat - p.dur - T0p) / (T1p - T0p), w: SPAN * p.dur / (T1p - T0p)});
  });

  // materials
  const mats = {};
  root.traverse(o => {
    if (!o.isMesh) return;
    const k = o.material.name.replace(/\.\d+$/, '');
    if (!FIN[k]) return;
    if (!mats[k]) mats[k] = {m: new THREE.MeshPhysicalMaterial({name:k}), meshes:[]};
    o.material = mats[k].m; mats[k].meshes.push(o);
  });
  for (const k in mats) {
    const f = FIN[k], m = mats[k].m;
    m.roughness = f.roughness; m.metalness = f.metalness;
    m.clearcoat = f.coat || 0; m.clearcoatRoughness = .04;
    if (f.gradient) { m.vertexColors = true; m.color.set(0xffffff); paintStock(mats[k].meshes, f.gradient); }
    else m.color.setStyle(f.color);
  }

  if (orbit && mats.stock) {
    // rifle builder: repaint the stock to match the configurator's finish (see emitConfig in configurator.js)
    const m = mats.stock.m, meshes = mats.stock.meshes;
    const leaves = addMapleLeaves(m, meshes[0].geometry);
    let lastFinish = '';
    const applyFinish = f => {
      if (!f) return;
      const canada = f.tier === 'CustomInquiry';   // custom inquiry previews the Canada design
      const sig = [f.tier, f.primary, f.secondary, canada].join('|');
      if (sig === lastFinish) return;   // config also fires for non-finish changes
      lastFinish = sig;
      let stops = FIN.stock.gradient, grain = false;
      if (f.tier === 'Stain') { stops = [[0, f.primary], [1, f.primary]]; grain = true; }
      else if (f.tier === 'Single') stops = [[0, f.primary], [1, f.primary]];
      else if (f.tier === 'Two') stops = [[.56, f.primary], [.62, f.secondary || f.primary]];   // primary at the butt, colour 2 toward the fore-end
      else if (canada) stops = [[.1, '#0b0b0b'], [.3, '#262626'], [.5, '#5e5e5e'], [.7, '#b4b4b4'], [.9, '#f2f2f2']];   // Canada livery: black butt fading to a white fore-end (even steps by eye)
      leaves.value = canada ? 1 : 0;
      paintStock(meshes, stops, grain);
      m.roughness = grain ? .5 : FIN.stock.roughness;
      m.clearcoat = grain ? .5 : 1;
    };
    document.addEventListener('projectlp:config', e => applyFinish(e.detail));
    applyFinish(window.projectlpConfig);
  }

  if (orbit && canvas.dataset.parts) {
    // rifle builder: swap each accessory (standing block, cheekpiece, pistol grip) for the selected option
    const groups = groupParts(await loadScene(canvas.dataset.parts));
    for (const g in groups) {
      const items = groups[g], spec = PARTS[g];
      if (!Object.keys(items).length) continue;
      const mat = mats[spec.mat] ? mats[spec.mat].m : finishMaterial(spec.mat);
      for (const k in items) { items[k].traverse(m => { if (m.isMesh) m.material = mat; }); items[k].visible = false; root.add(items[k]); }
      const builtIn = root.getObjectByName(spec.builtIn);
      if (builtIn) builtIn.visible = false;
      const show = cfg => { const k = partFor(g, cfg); for (const n in items) items[n].visible = n === k; };
      document.addEventListener('projectlp:config', e => show(e.detail));
      show(window.projectlpConfig);
    }
  }

  if (orbit) {
    // rifle builder: the viewer column pins below the header (see .pdp-gallery in rifle-builder.liquid)
    const nav = document.querySelector('.nav-split');
    const setPin = () => document.documentElement.style.setProperty('--pin-top', (nav ? nav.offsetHeight : 0) + 'px');
    setPin(); addEventListener('resize', setPin);
  }

  if (orbit) {
    // rifle builder: 03 · Left / right hand mirrors the whole rifle in place
    const follow = cfg => setHand(hand, isLeft(cfg), ctr.z);
    document.addEventListener('projectlp:config', e => follow(e.detail));
    follow(window.projectlpConfig);
  }

  // hero copy: on narrow screens the rifle lives in the free band above it
  const copy = orbit ? null : host.querySelector('.hero-content');
  const copyTop = copy && (copy.firstElementChild || copy);
  let wide = false, yOff = 0;
  function fit(){
    const w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false); camera.aspect = w / h;
    wide = camera.aspect > 1.1;
    // keep the rifle in frame on narrow screens
    let k = Math.max(1, (orbit ? 1.6 : 1.25) / camera.aspect);
    yOff = 0;
    if (copyTop && !wide) {
      // free band = stage top .. top of the first line of copy (less a gap)
      const band = Math.max(h * .28, copyTop.getBoundingClientRect().top - canvas.getBoundingClientRect().top - 16);
      yOff = (h - band) / 2;                    // centre the rifle in that band
      k = Math.max(k, .78 * h / band);          // and shrink it if the band is too short
    }
    camera.userData.dist = R * (orbit ? 1.5 : 1.55) * k;
    camera.updateProjectionMatrix();
  }
  const ro = new ResizeObserver(fit); ro.observe(canvas); if (copy) ro.observe(copy); fit();
  if (document.fonts) document.fonts.ready.then(fit);
  camera.position.copy(ctr).add(new THREE.Vector3(.55, .28, .9).normalize().multiplyScalar(camera.userData.dist));
  if (orbit) {
    controls.update(); controls.saveState();
    // slow turntable until the visitor grabs it
    controls.autoRotate = !reduce; controls.autoRotateSpeed = .8;
    controls.addEventListener('start', () => { controls.autoRotate = false; });
    const reset = host.querySelector('[data-mk61-reset]');
    if (reset) reset.addEventListener('click', () => { controls.reset(); });
  }

  let p = orbit ? 1 : 0, ps = p, last = performance.now();
  function progress(){
    const r = host.getBoundingClientRect(), H = r.height - stage.offsetHeight;
    return H > 0 ? clamp01((stage.getBoundingClientRect().top - r.top) / H) : 1;
  }
  const q = new THREE.Quaternion(), Rv = new THREE.Vector3(), v = new THREE.Vector3();
  function tick(t){
    const dt = Math.min(.1, (t - last) / 1000); last = t;
    p = (reduce || orbit) ? 1 : progress(); ps += (p - ps) * (1 - Math.exp(-dt / .14));
    // magnetic snap: hover -> accelerating pull -> clunk (assembly recoils, part bounces)
    Rv.set(0, 0, 0);
    for (const s of parts){
      const tt = clamp01((ps - s.a) / s.w);
      if (tt >= 1 && s.prev < 1 && !reduce) s.hit = t;
      if (tt < 1) s.hit = null;
      s.prev = tt;
      if (s.hit != null) {
        const k = (t - s.hit) / 1000;
        if (k < 1.2) Rv.addScaledVector(s.dir, -s.amp * Math.exp(-9 * k) * Math.sin(2 * Math.PI * 5.5 * k));
      }
    }
    root.position.copy(Rv);
    for (const s of parts){
      const tt = s.prev, u = 1 - Math.pow(tt, 3.2);
      let off = s.dist * u;
      if (tt <= 0) off *= 1 + .035 * Math.sin(t / 770 + s.a * 40);    // idle hover
      if (s.hit != null) { const k = (t - s.hit) / 1000;
        off += .8 * s.amp * Math.exp(-11 * k) * Math.abs(Math.sin(2 * Math.PI * 6.5 * k)); }
      s.o.position.copy(s.home).addScaledVector(s.dir, off);
      const al = 1 - Math.min(1, tt / .75); q.setFromAxisAngle(s.ax, s.ang * al * al * (3 - 2 * al));
      s.o.quaternion.copy(s.q0).premultiply(q);
    }
    if (!orbit) {
      // keep the rifle clear of the hero copy: right of it when wide, in the band above it when narrow
      const w = canvas.clientWidth, h = canvas.clientHeight;
      if (w && h) camera.setViewOffset(w, h, wide ? -w * .21 : 0, wide ? 0 : yOff, w, h);
      // hold the framing distance (orbit stays user-controlled) so the rifle never grows into the copy
      const want = camera.userData.dist;
      v.copy(camera.position).sub(controls.target);
      v.setLength(v.length() + (want - v.length()) * .08); camera.position.copy(controls.target).add(v);
    }
    controls.update(); renderer.render(scene, camera);
  }
  runWhileVisible(host, tick);

  host.classList.add('is-ready');
}

// Accessory close-up: the accessory the visitor changed most recently (standing block first), framed to fill the view.
async function mountAccessory(host){
  const wrap = host.closest('.pdp-3d-acc') || host;
  const canvas = host.querySelector('canvas'), label = wrap.querySelector('[data-mk61-label]'), title = wrap.querySelector('[data-mk61-title]');
  // translated display names from the configurator's data-i18n (rifle-builder.liquid); English PARTS labels are the fallback
  let i18n = {};
  try { i18n = JSON.parse((document.querySelector('[data-configurator]') || {dataset: {}}).dataset.i18n || '{}'); } catch (e) {}
  const {renderer, scene, camera, controls} = makeViewer(canvas, true);
  // headlight: whichever side the visitor turns toward stays lit
  const head = new THREE.DirectionalLight(0xffffff, 1.4); head.position.set(.4, .5, 1); camera.add(head); scene.add(camera);
  const groups = groupParts(await loadScene(canvas.dataset.parts));
  const hand = new THREE.Group(); scene.add(hand);
  for (const g in groups) {
    const mat = finishMaterial(PARTS[g].mat); mat.color.setStyle(g === 'CP' ? '#5a5c62' : '#3a3a40');   // a touch lighter than on the rifle so the shape reads up close
    for (const k in groups[g]) { groups[g][k].traverse(m => { if (m.isMesh) m.material = mat; }); groups[g][k].visible = false; hand.add(groups[g][k]); }
  }
  let curGroup = 'SB', cur = null, left = false, prev = null;
  const view = new THREE.Vector3(.55, .25, .9).normalize();
  function frame(){
    const box = new THREE.Box3().setFromObject(groups[curGroup][cur]);
    const c = box.getCenter(new THREE.Vector3()), r = box.getSize(new THREE.Vector3()).length();
    const dist = r * 1.45 * Math.max(1, 1.2 / camera.aspect);
    controls.target.copy(c); camera.position.copy(c).addScaledVector(view, dist);
    controls.minDistance = dist * .35; controls.maxDistance = dist * 2.5;
    controls.update(); controls.saveState();
  }
  function show(cfg){
    // focus the group whose selection just changed
    if (prev && cfg) for (const g in PARTS) if (cfg[PARTS[g].cfg] !== prev[PARTS[g].cfg] && Object.keys(groups[g]).length) curGroup = g;
    prev = cfg ? {...cfg} : prev;
    const k = partFor(curGroup, cfg), l = !!cfg && cfg.side === 'Left';
    const node = groups[curGroup][k];
    if (!node || (node.visible && l === left)) return;
    for (const g in groups) for (const n in groups[g]) groups[g][n].visible = groups[g][n] === node;
    cur = k; left = l; setHand(hand, l); frame();
    if (label) label.textContent = (i18n.part_options || {})[k] || PARTS[curGroup].labels[k];
    if (title) title.textContent = (i18n.parts || {})[curGroup] || PARTS[curGroup].title;
  }
  function fit(){
    const w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
    if (cur) frame();
  }
  new ResizeObserver(fit).observe(canvas); fit();
  document.addEventListener('projectlp:config', e => show(e.detail));
  show(window.projectlpConfig);

  controls.autoRotate = !reduce; controls.autoRotateSpeed = 1.2;
  controls.addEventListener('start', () => { controls.autoRotate = false; });
  const reset = host.querySelector('[data-mk61-reset]');
  if (reset) reset.addEventListener('click', () => { controls.reset(); });

  runWhileVisible(host, () => { controls.update(); renderer.render(scene, camera); });
  host.classList.add('is-ready');
}

// Canada livery: a scattered field of red maple leaves over the stock. The stock has no UVs, so the
// leaves are projected side-on (local x = along the stock, y = up) in the stock material's fragment
// shader. Every grid cell (~1/18 of the stock length) may hold one leaf with its own position, size,
// tilt and strength (from solid red to a faint ghost); neighbours are checked so leaves can overlap.
// Returns the on/off uniform.
function addMapleLeaves(material, geometry){
  geometry.computeBoundingBox();
  const bb = geometry.boundingBox;
  const len = bb.max.x - bb.min.x, tile = len / 18;
  // leaf mask: the Canadian flag's 11-point leaf, white on transparent
  const cv = document.createElement('canvas'); cv.width = cv.height = 256;
  const g = cv.getContext('2d');
  const pts = [[0,-48],[5,-34],[13,-38],[10,-18],[26,-28],[28,-20],[40,-24],[32,-6],[36,-2],[20,8],[22,16],[4,10],[3,30],
               [-3,30],[-4,10],[-22,16],[-20,8],[-36,-2],[-32,-6],[-40,-24],[-28,-20],[-26,-28],[-10,-18],[-13,-38],[-5,-34]];
  g.fillStyle = '#fff'; g.beginPath();
  pts.forEach(([x, y], i) => g[i ? 'lineTo' : 'moveTo'](128 + x * 2.4, 136 + y * 2.4));
  g.closePath(); g.fill();
  const tex = new THREE.CanvasTexture(cv);
  const uniforms = {
    uLeaf: {value: 0}, uLeafMap: {value: tex}, uLeafRed: {value: new THREE.Color('#d52b1e')},
    uLeafX0: {value: bb.min.x}, uLeafY0: {value: bb.min.y}, uLeafTile: {value: tile}, uLeafCols: {value: Math.round(len / tile)},
  };
  material.onBeforeCompile = sh => {
    Object.assign(sh.uniforms, uniforms);
    sh.vertexShader = sh.vertexShader
      .replace('#include <common>', '#include <common>\nvarying vec3 vLeafPos;')
      .replace('#include <begin_vertex>', '#include <begin_vertex>\nvLeafPos = position;');
    sh.fragmentShader = sh.fragmentShader
      .replace('#include <common>', `#include <common>
varying vec3 vLeafPos;
uniform float uLeaf, uLeafX0, uLeafY0, uLeafTile, uLeafCols;
uniform sampler2D uLeafMap;
uniform vec3 uLeafRed;
float leafHash(vec2 p){ return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }`)
      .replace('#include <color_fragment>', `#include <color_fragment>
if (uLeaf > .5) {
  vec2 q = (vLeafPos.xy - vec2(uLeafX0, uLeafY0)) / uLeafTile;
  vec2 cell = floor(q);
  for (int dx = -1; dx <= 1; dx++) for (int dy = -1; dy <= 1; dy++) {
    vec2 cc = cell + vec2(float(dx), float(dy));
    if (cc.x < 1. || cc.x > uLeafCols - 2. || leafHash(cc) > .8) continue;          // ~80% of cells hold a leaf; keep the very ends clear
    vec2 ctr = cc + .5 + (vec2(leafHash(cc + 3.1), leafHash(cc + 5.7)) - .5) * .7;   // jittered centre
    float sz = mix(.7, 1.6, leafHash(cc + 9.2));                                      // size, in cells
    float a = (leafHash(cc + 11.3) - .5) * 1.4;                                       // tilt, about +/-40 degrees
    vec2 c = mat2(cos(a), -sin(a), sin(a), cos(a)) * ((q - ctr) / sz);
    vec2 uv = c * vec2(1., -1.) + .5;
    if (any(lessThan(uv, vec2(0.))) || any(greaterThan(uv, vec2(1.)))) continue;
    float strength = mix(.18, 1., pow(leafHash(cc + 13.9), .7));                      // solid red down to a faint ghost
    diffuseColor.rgb = mix(diffuseColor.rgb, uLeafRed, texture2D(uLeafMap, uv).a * strength);
  }
}`);
  };
  material.customProgramCacheKey = () => 'mk61-maple';
  material.needsUpdate = true;
  return uniforms.uLeaf;
}

function paintStock(meshes, stops, grain = false){
  const cs = stops.map(([p, h]) => [p, new THREE.Color().setStyle(h)]), c = new THREE.Color();
  for (const o of meshes) {
    const g = o.geometry; g.computeBoundingBox();
    const bb = g.boundingBox, x0 = bb.min.x, x1 = bb.max.x, P = g.attributes.position;
    const ry = (bb.max.y - bb.min.y) || 1, rx = (x1 - x0) || 1;
    const col = new Float32Array(P.count * 3);
    for (let i = 0; i < P.count; i++) {
      const u = (P.getX(i) - x0) / (x1 - x0);
      let k = 0; while (k < cs.length - 1 && u > cs[k+1][0]) k++;
      if (u <= cs[0][0]) c.copy(cs[0][1]); else if (k >= cs.length - 1) c.copy(cs[cs.length-1][1]);
      else c.copy(cs[k][1]).lerp(cs[k+1][1], (u - cs[k][0]) / (cs[k+1][0] - cs[k][0]));
      if (grain) {
        // cheap wood grain: wavy bands running butt -> fore-end
        const y = (P.getY(i) - bb.min.y) / ry, x = (P.getX(i) - x0) / rx;
        const band = Math.sin((y * 16 + Math.sin(x * 9) * .9 + Math.sin(x * 37) * .15) * Math.PI * 2);
        c.multiplyScalar(.8 + .2 * (.5 + .5 * band));
      }
      col[i*3] = c.r; col[i*3+1] = c.g; col[i*3+2] = c.b;
    }
    g.setAttribute('color', new THREE.BufferAttribute(col, 3));
    g.attributes.color.needsUpdate = true;
  }
}

document.querySelectorAll('[data-mk61]').forEach(host => (host.dataset.mk61 === 'accessory' ? mountAccessory : mount)(host).catch(err => {
  console.warn('MK6.1 viewer failed', err);
  host.classList.add('is-failed');
}));
